import { connect, Dispatch } from 'react-redux';
import { RootState } from '../../../store/reducers';
import { secondaryNavNextClick } from '../../../store/action';
import SecondaryNav from './SecondaryNav';
import { SecondaryNavActions, secondaryNavPreviousClick } from '../../../store/action/secondaryNavActions';
import { DELTA, GENERAL, NONE, PROFILE } from '../../../store/constants';
import { SelectedOptions } from '../../../store/reducers/deltaReducer';

function profileCanGoNext(profileIsValid: boolean, navId: string) {
    return profileIsValid && navId === PROFILE;
}

function generalCanGoNext(generalIsValid: boolean, navId: string) {
    return generalIsValid && navId === GENERAL;
}

function profileCanGoPrevious() {
    return false;
}

function generalCanGoPrevious(navId: string) {
    return navId === GENERAL;
}

function deltaCanGoNext(navId: string, selectedOptions: SelectedOptions, activePanel: string): boolean {
    if (navId !== DELTA) {
        return false;
    }

    return selectedOptions[activePanel] !== NONE;
}

function deltaCanGoPrevious() {
    return true;
}

const mapStateToProps = (state: RootState) => {
    const { appReducer, navReducer, profileReducer, deltaReducer } = state;
    const { loading } = appReducer;
    const { navId } = navReducer;
    const { selectedOptions, activePanel } = deltaReducer;
    const { isValid: profileIsValid } = profileReducer;

    let previousDisabled = true;
    let nextDisabled = true;

    const profileNext = profileCanGoNext(profileIsValid, navId);
    const profilePrevious = profileCanGoPrevious();

    const generalNext = generalCanGoNext(true, navId);
    const generalPrevious = generalCanGoPrevious(navId);
    const deltaNext = deltaCanGoNext(navId, selectedOptions, activePanel);

    if (profileNext || generalNext || deltaNext) {
        nextDisabled = false;
    }

    if (profilePrevious || generalPrevious || deltaCanGoPrevious()) {
        previousDisabled = false;
    }

    return {
        loading,
        navId,
        previousDisabled,
        nextDisabled
    };
};

const mapDispatchToProps = (dispatch: Dispatch<SecondaryNavActions>) => {
    return {
        next(): void {
            dispatch(secondaryNavNextClick());
        },
        previous(): void {
            dispatch(secondaryNavPreviousClick());
        }
    };
};

const SecondaryNavContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SecondaryNav);

export default SecondaryNavContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/bottomNav/SecondaryNavContainer.tsx